import { Typography } from '@mui/material';
import { media } from 'breakpoints';
import styled from 'styled-components';
import { getSpacing, typography } from 'stylesheet';

export const FormContainer = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${getSpacing(3)};
  margin-bottom: ${getSpacing(3)};
  > * {
    font-size: ${getSpacing(1.75)};
  }
  ${media.xs`
    gap: 16px;
  `}
`;

export const FormRowContainer = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  gap: ${getSpacing(3)};
  > * {
    flex: ${(props) => (props.$fullWidth ? 1 : 0.5)};
  }
  ${media.xs`
    flex-direction: column;
    gap: 16px;
  `}
`;

export const ButtonsContainer = styled.div`
  margin-top: ${getSpacing(1)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${getSpacing(1)};
  white-space: nowrap;
  overflow: visible;
  > * {
    font-size: ${getSpacing(1.75)};
  }
`;

export const FormRequiredFieldMessage = styled(Typography)`
  ${typography.p3_regular};
`;
